'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = fieldErrorWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/FieldErrorWrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function fieldErrorWrapper(Component) {
  var FieldError = function (_BcReactComponent) {
    _inherits(FieldError, _BcReactComponent);

    function FieldError(props) {
      _classCallCheck(this, FieldError);

      var _this = _possibleConstructorReturn(this, (FieldError.__proto__ || Object.getPrototypeOf(FieldError)).call(this, props));

      _this.bindAll('renderErrors');
      return _this;
    }

    _createClass(FieldError, [{
      key: 'renderErrors',
      value: function renderErrors() {
        var _props = this.props,
            fieldErrors = _props.fieldErrors,
            errorKey = _props.errorKey;


        if (fieldErrors && errorKey && fieldErrors[errorKey]) {
          var id = fieldErrors[errorKey].id || fieldErrors[errorKey].classification && 'error_' + fieldErrors[errorKey].classification.toLowerCase() || '';
          var defaultMessage = fieldErrors[errorKey].message;
          var values = fieldErrors[errorKey].values;

          return _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: id,
              values: values,
              defaultMessage: defaultMessage })
          );
        }
        return null;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            fieldErrors = _props2.fieldErrors,
            errorKey = _props2.errorKey,
            otherProps = _objectWithoutProperties(_props2, ['fieldErrors', 'errorKey']);

        var errorClass = fieldErrors && errorKey && fieldErrors[errorKey] ? 'has-error' : '';

        return _react2.default.createElement(
          'div',
          { className: 'cp-field-error-wrapper ' + errorClass },
          this.renderErrors(),
          _react2.default.createElement(Component, _extends({
            ref: function ref(el) {
              return _this2._wrappedComponent = el;
            }
          }, otherProps))
        );
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        return this._wrappedComponent;
      }
    }]);

    return FieldError;
  }(_baseBcReactComponent2.default);

  FieldError.propTypes = {
    fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape)),
    errorKey: _react.PropTypes.string
  };

  return FieldError;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-field-error-wrapper/lib/components/FieldErrorWrapper.component.js
// module id = 1483
// module chunks = 1